// extracted by mini-css-extract-plugin
module.exports = {"invoiceHeader":"InvoiceHeaderInfo_invoiceHeader__k_zsJ","invoiceHeaderTitle":"InvoiceHeaderInfo_invoiceHeaderTitle__2fqpw","roleInfo":"InvoiceHeaderInfo_roleInfo__yXhjq"};